module.exports = __webpack_public_path__ + "img/downloadApp21.3f5eda96.svg";